export const LATEST_WINNERS_SIZE = 50;